import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@material-ui/icons/Search';
import { isDark } from '../../../types/Theme';
var useStyles = makeStyles(function (theme) { return ({
    containerDark: {
        backgroundColor: theme.palette.background.paper,
    },
    container: {
        width: '100%',
    },
    alignment: {
        textAlign: 'center',
    },
    searchIcon: {
        fontSize: '70px',
        marginTop: '15px',
    },
    titleMargin: {
        marginBottom: '15px',
    },
}); });
var NoResults = function () {
    var t = useTranslation().t;
    var classes = useStyles();
    var dark = isDark();
    return (React.createElement("div", { className: "".concat(dark ? classes.containerDark : '', " ").concat(classes.alignment, " ").concat(classes.container) },
        React.createElement("div", { className: classes.searchIcon },
            React.createElement(SearchIcon, { fontSize: "inherit" })),
        React.createElement(Typography, { variant: "h6", color: "textSecondary", className: classes.titleMargin }, t('No results found')),
        React.createElement(Typography, { variant: "body2" }, t("Try adjusting your search to find what you're looking for"))));
};
export default NoResults;
//# sourceMappingURL=NoResults.js.map